import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

const config = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}` },
});

const url = (bookingId) => `${API_BASE_URL}/api/admin/bookings/${bookingId}/customer-payments`;

export const getBookingCustomerPayments = async (bookingId) =>
  (await axios.get(url(bookingId), config())).data;

export const recordBookingCustomerPayment = async (bookingId, payment) =>
  (await axios.post(url(bookingId), payment, config())).data;

// Corrections need a reason; a delete keeps the payment on record but out of every total.
export const editBookingCustomerPayment = async (bookingId, paymentId, change) =>
  (await axios.put(`${url(bookingId)}/${paymentId}`, change, config())).data;

export const deleteBookingCustomerPayment = async (bookingId, paymentId, reason) =>
  (await axios.post(`${url(bookingId)}/${paymentId}/delete`, { reason }, config())).data;
